import { useWorkflowFieldValues } from 'features/libra/fieldValues/useWorkflowFieldValues'
import { useActiveScopeOntologyFields } from 'features/libra/ontology/useOntologyFields'
import {
  LibraWorflowStepComponentProps,
  UseValidateConfigHook,
} from 'features/libra/workflow/workflowStepsApi'
import { useMemo } from 'react'

import {
  ConditionalFormConfig,
  ConditionalFormConfigSchema,
} from './conditionalForm/api/conditionalFormApi'
import { ConditionalFormView } from './conditionalForm/ConditionalFormView'

export const useValidateConfig: UseValidateConfigHook = ({ config }) =>
  useMemo(() => ConditionalFormConfigSchema.safeParse(config).success, [config])

export const Component = ({
  config,
  readonly,
}: LibraWorflowStepComponentProps<ConditionalFormConfig>) => {
  const { ontologyFields } = useActiveScopeOntologyFields()
  const parsedConfig = useMemo(
    () => ConditionalFormConfigSchema.parse(config),
    [config]
  )
  const formState = useWorkflowFieldValues({ ontologyFields, ...parsedConfig })
  return (
    <ConditionalFormView
      config={parsedConfig}
      ontologyFields={ontologyFields}
      formState={formState}
      readonly={Boolean(readonly)}
    />
  )
}
